import styled from "styled-components"

export const Container = styled.div`
  height: 100%;
  background: #24292E;
  padding: 3.5%;  
  .events-container {
    background: #3F4448;
    height: 100%;
    border-radius: 5px;
    position: relative;
    overflow-y: auto; 
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }
    &::-webkit-scrollbar-thumb {
      background-color: darkgrey;
      outline: 1px solid slategrey;
      border-radius: 23px;

    }
    .btn-wrapper {
      position: absolute;
      right: 0;
      height: 100%;
      width: 75px;
      overflow: auto;
      .copy {
        width: 75px;
        height: 40px;
        opacity: 0.75;
        transition: 0.25s;
        position:fixed;
        &:hover {
          opacity: 1;
        }
      }
    }
    .content {
      padding: 1em;
      line-height: 40px;
      overflow: auto;
      color: #fff;
      p {
        color: rgba(255,255,255,0.75);
      }
    }
    .loader {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background: #3F4448;
    }
  }
  
`



// WEBPACK FOOTER //
// ./src/components/Main/styles.js